import { OrderStatus } from "@/constants/order";

import type { OrderPayment, PatchOrderPayment } from "@/api/orders/dto/order.dto";

function serializeOrderPayments(payments: OrderPayment[]): string {
  return JSON.stringify(
    payments.map((payment) => ({
      id: payment.id,
      tempId: payment.tempId,
      type: payment.type,
      rate: payment.rate,
      isActive: payment.isActive,
      isDeleted: Boolean(payment.isDeleted),
    })),
  );
}

export function isOrderPaymentsChanged(initial: OrderPayment[], current: OrderPayment[]): boolean {
  return serializeOrderPayments(initial) !== serializeOrderPayments(current);
}

export function isInvoiceDeletedByStatusChange(from: OrderStatus | undefined, to: OrderStatus): boolean {
  if (!from || from === to) {
    return false;
  }

  if (to === OrderStatus.cancelled) {
    return true;
  }

  if (from === OrderStatus.waitingTonu) {
    return to === OrderStatus.noTonu;
  }

  if (from === OrderStatus.tonu) {
    return to === OrderStatus.unassigned || to === OrderStatus.waitingTonu;
  }

  return false;
}

export function getOrderPaymentInvoiceIds(payments: OrderPayment[]): string[] {
  const invoiceIds = payments
    .map((payment) => payment.invoiceId)
    .filter((invoiceId): invoiceId is string => Boolean(invoiceId));

  return Array.from(new Set(invoiceIds));
}

function isOrderPaymentChanged(initial: OrderPayment, current: OrderPayment): boolean {
  return (
    initial.type !== current.type ||
    initial.rate !== current.rate ||
    Boolean(initial.isDeleted) !== Boolean(current.isDeleted)
  );
}

export function getChangedOrderPayments(initial: OrderPayment[], current: OrderPayment[]): PatchOrderPayment[] {
  return current
    .filter((payment) => {
      if (!payment.id) {
        return true;
      }

      const initialPayment = initial.find((item) => item.id === payment.id);

      return !initialPayment || isOrderPaymentChanged(initialPayment, payment);
    })
    .map((payment) => ({
      id: payment.id,
      type: payment.type,
      rate: payment.rate,
      isDeleted: Boolean(payment.isDeleted),
    }));
}
